// Cómo se cuenta al usuario la política de la verificación en dos pasos (MT-043-C): puro, para probarlo sin pantalla.
import type { EstadoMfa } from '@/lib/hceMfa';

/** La fecha en la hora de Ecuador (la política se fija en AAAA-MM-DD de Ecuador), p. ej. «1 de noviembre de 2026». */
export function fechaLargaEcuador(iso: string): string {
  const f = new Date(iso);
  if (Number.isNaN(f.getTime())) return iso;
  return new Intl.DateTimeFormat('es-EC', { timeZone: 'America/Guayaquil', day: 'numeric', month: 'long', year: 'numeric' }).format(f);
}

export type TextoPolitica = { clave: string; valores?: Record<string, string> };

/** Qué decirle a la persona de la política vigente (clave i18n + valores). `null` si no hay nada que decir. */
export function fechaDePolitica(p: Pick<EstadoMfa['politica'], 'obligatorio' | 'desde' | 'invalida'>): TextoPolitica | null {
  if (p.invalida) return { clave: 'seguridad.politica.invalida' };
  if (p.obligatorio) return p.desde ? { clave: 'seguridad.politica.obligatoriaDesde', valores: { fecha: fechaLargaEcuador(p.desde) } } : { clave: 'seguridad.politica.obligatoriaYa' };
  if (p.desde) return { clave: 'seguridad.politica.seraObligatoria', valores: { fecha: fechaLargaEcuador(p.desde) } };
  return { clave: 'seguridad.politica.opcional' };
}
